import { transformDataTestIds } from '@backoffice-frontend/common'
import { EmployeeAreaId } from './EmployeeAreaId'

const BaseEmployeeAreaDataTestIds = {
  Base: EmployeeAreaId,
  Navigation: 'navigation',
  Details: {
    Base: 'details',
    EmployeeNotes: {
      Base: 'notes',
      SubjectDropdown: 'subject-dropdown',
    },
    Messaging: {
      Base: 'messaging',
      List: 'list',
      TableRow: 'table-row',
    },
    Tips: {
      Base: 'tips',
      PeriodsList: {
        Base: 'periods-list',
        Table: 'table',
        TableRow: 'table-row',
      },
    },
  },
}

export const EmployeeAreaDataTestIds = transformDataTestIds(
  BaseEmployeeAreaDataTestIds,
)
